/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {bus} from '@/main';

export default {
  name: 'header-before-login',
  components: {},
  props: [],
  data () {
    return {
      togglePopup: false,
      showHeaderbtn: true,
      showSignup: true,
      showLogin: true,
      showHomeMenu:true,
      showQuizMenu:true,
      navOpen:false,
      isMobile:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('hideHeaderbtn', (data) => {
      this.showHeaderbtn = data;
    })
    bus.$on('showQuizMenubtn', (data) => {
      this.showQuizMenu = data;
    })
    bus.$on('showLoginbtn', (data) => {
      this.showLogin = data;
    })
    bus.$on('showHomeMenuBtn', (data) => {
      this.showHomeMenu = data;
    })
    bus.$on('showRegisterbtn', (data) => {
      this.showSignup = data;
    })
    $(document).ready(function(){
    $(".Q_btn").click( function(){
      $(window).scrollTop(0);
      $(".firstbanner-in").toggleClass("active");
      $("body").toggleClass("login_box_hide");
    });
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".Q_btn, .welcome_popup .light_bg_section").length) {
      $("body").find(".firstbanner-in").removeClass("active");
      $("body").removeClass("login_box_hide");
      }
    });
  });
  },
  methods: {
    movingSlideMethod(){
      bus.$emit('movingSlideStateBus', 3);
    },
    onResize() {
      this.isMobile = window.innerWidth < 1023;
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg'); 
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
        }
    },
    togglePopupFunction(){
      this.togglePopup = !this.togglePopup;
      bus.$emit('togglePopipOverlay', this.togglePopup);
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.onResize, {
      passive: true
    })
    this.onResize()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {
        passive: true
      })
    }
  },
}